export const RC_COLLAPSE_LIST_POINT = '1420px'
export const RC_STACK_ROW_CARDS = '1250px'
/**
 * Single knob for drawer “compact / mobile-ish” layouts (Themis row, Sender Analysis,
 * Phishing SOC, etc.). Passed as dualMaxWidth `paneWidth` via `drawerCompactOpts()`.
 * Legacy viewport breakpoints are unchanged.
 */
export const RC_DRAWER_STACK_ROW_CARDS = '800px'
export const RC_TABLET_POINT = '1050px'
export const RC_TABLET_POINT_MIN = '1051px'
export const RC_PHONE_POINT = '750px'
